import {Radio} from 'antd'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback} from 'react'
import {NullAsDefault} from 'views/Shared'
import {StatusOptions} from "../../../AppLocals/CatholicHousehold/consts/StatusOptions";

export const CatholicHouseholdFilter = ({
    value: filter = {
        status: undefined,
    },
    onChange: setValues = NullAsDefault,
    ...props
}) => {
    const t = useTranslate()

    const handleChange = useCallback(
        (name, value) => {
            setValues({
                ...filter,
                [name]: value,
            })
        },
        [filter]
    )

    return (
        <div className="flex flex-col items-center gap-2 mt-2">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 w-full items-center">
                <div />
                <Radio.Group
                    name="status"
                    optionType="button"
                    buttonStyle="solid"
                    className="flex items-center justify-end custom-radio-button w-full lg:w-auto"
                    onChange={(event) => {
                        const {name, value} = event.target;
                        handleChange(name, value)
                    }}
                    value={String(filter.status) || undefined}>
                    {[StatusOptions.rejected, StatusOptions.closed, StatusOptions.pending, StatusOptions.normal].map(
                        ({label, value}) => (
                            <Radio
                                key={value}
                                className="px-3 text-sm flex-no-wrap truncate"
                                value={String(value)}>
                                {t(label)}
                            </Radio>
                        )
                    )}
                </Radio.Group>
            </div>

        </div>
    )
}

export default CatholicHouseholdFilter
